import '../shared/TagListing.less';
import React from 'react';
import { SectionProps } from '../types';
import SectionCompetitorResults from '../shared/SectionCompetitorResults';
import SectionMessage from '../shared/SectionMessage';
import SectionTitle from '../shared/SectionTitle';
import SectionTooltip from '../shared/SectionTooltip';
import { Tag } from 'antd';

export default function CommonKeywordsSection({ sectionKey, title, url, relevance, tooltip, result, competitorsResults, passRate }: SectionProps) {
    const hasCompetitors = competitorsResults && Object.keys(competitorsResults).length > 0;

    return (
        <div
            id={sectionKey}
            className="report-element default"
        >
            <SectionTitle title={title} />

            <div className="report-element-description">
                <SectionMessage
                    url={url}
                    status={result.status}
                    relevance={relevance}
                    message={result.message}
                    hasCompetitors={hasCompetitors}
                />

                {<CommonKeywordsResult keywordsFrequency={result.keywords_frequency} />}

                {hasCompetitors && (
                    <SectionCompetitorResults
                        results={competitorsResults}
                        relevance={relevance}
                        render={(result) => <CommonKeywordsResult keywordsFrequency={result.keywords_frequency} />}
                        hideMessage={true}
                    />
                )}
            </div>

            <SectionTooltip tooltip={tooltip} />
        </div>
    );
}

type CommonKeywordsResultProps = {
    keywordsFrequency: {
        [keyword: string]: number;
    };
};

function CommonKeywordsResult({ keywordsFrequency }: CommonKeywordsResultProps) {
    return (
        <div className="description-meta">
            <div className="tag-listing">
                {keywordsFrequency &&
                    Object.entries(keywordsFrequency)
                        .sort(([_0, firstFrequency], [_1, secondFrequency]) => secondFrequency - firstFrequency)
                        .map(([keyword, frequency]) => (
                            <Tag
                                className="default"
                                key={keyword}
                            >
                                <span className="tag-count">{frequency}</span>
                                <span className="tag-name">{keyword}</span>
                            </Tag>
                        ))}
            </div>
        </div>
    );
}
